import { ref, Ref } from "vue";

function useText(defaultText: string = "") {
  // Typage explicite pour `refText` comme Ref<string>
  const refText: Ref<string> = ref(defaultText);

  // Typage explicite pour la fonction `doChangeText`
  const doChangeText = (newText: string): void => {
    refText.value = newText;
  };

  return {
    refText,
    doChangeText,
  };
}

export default useText;
